import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { setTypeTransactionOption } from '../../../../../../../../redux/fetchActions/legadoPage/transferApp';
import Wrapper from '../../../../../../../../shared/components/Wrapper';
import { codmensagem } from '../../../../../../../../utils/businessRule';

function setType() {
  const dispatch = useDispatch();
  const clientsFilterState = useSelector(
    (reducer: IReducer) => reducer.transfersFilterApp
  );

  function SetTypeTransaction(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setTypeTransactionOption(value));
  }

  const transformedArray = Object.entries(codmensagem);
  return (
    <Wrapper.Default isActive flexDirection="column" alignItens="start">
      <span
        style={{ paddingBottom: '5px', fontWeight: 700, lineHeight: '16px' }}>
        Tipo de transação:
      </span>
      <Form.Control
        as="select"
        value={clientsFilterState.type_transaction}
        onChange={(event) => SetTypeTransaction(event)}>
        {transformedArray.map((item, index) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <option key={index} value={item[1]}>
              {item[0]}
            </option>
          );
        })}
      </Form.Control>
    </Wrapper.Default>
  );
}

export default setType;
